import { reducer as news } from 'modules/news';
import { reducer as partners } from 'modules/partners';
import { reducer as info } from 'modules/info';
import { reducer as pins } from 'modules/pins';
import { reducer as venues } from 'modules/venues';
import { reducer as maps } from 'modules/maps';
import { reducer as files } from 'modules/uploader';
import { reducer as sortable } from 'modules/sortable';
import { reducer as imports } from 'modules/imports';
import { reducer as images } from 'modules/images';

export default {
    news,
    partners,
    info,
    pins,
    venues,
    maps,
    imports,
    files,
    sortable,
    images,
};
